import { IStock } from '@notino/shared/definitions/custom-definitions';

import { getRenderableAttributes } from '@components/Tags/utils';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { AB_TEST_ORIGINAL_PRICE_DISCOUNT_PERCENTAGE_THRESHOLD } from '../../hooks/usePriceLogic';
import { getDiscountPercentage } from '../../hooks/usePriceLogic/utils';
import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';

import { useShouldRenderTagDiscount } from './shouldRenderTagDiscount';

export const useShouldRenderEligibleAction = () => {
  const { currentVariant } = useProductDetailContext();
  const shouldRenderTags = useShouldRenderTagDiscount(currentVariant);
  const hasVoucherDiscount = !!useResolvedVoucherDiscount();
  const { experiment_pd_action_percentage_from_rrp } = useFeatureFlags();

  if (
    !shouldRenderTags ||
    hasVoucherDiscount ||
    currentVariant.stockAvailability.code === IStock.outOfStock
  ) {
    return false;
  }

  const attributes = getRenderableAttributes(currentVariant.attributes);
  const isEligible = currentVariant?.recentMinPrice?.isActionEligible;

  if (experiment_pd_action_percentage_from_rrp) {
    return (
      isEligible ||
      getDiscountPercentage(
        currentVariant.price.value,
        currentVariant.originalPrice?.value || 0
      ) >= AB_TEST_ORIGINAL_PRICE_DISCOUNT_PERCENTAGE_THRESHOLD
    );
  }

  return Boolean(attributes.Action) && isEligible;
};
